<script setup lang="ts">
  import { computed } from 'vue';
  import { useRouter } from 'vue-router';
  import RecommRow from './RecommendationRow.vue';
  import { DefaultTable, ColoredButton, SearchNoResults } from '@/shared/ui';
  import { DocumentTableProps } from '@/entities/Document';
  import { HOME_SEARCH_DEFAULTS } from '@/pages/home/model';
  import type { HomeSearchCriteria, HomeSearchItemType } from '@/pages/home/model';

  interface Props extends DocumentTableProps {
    searchTerm: string;
    searchCriteria?: HomeSearchCriteria;
    activeItemType?: HomeSearchItemType;
  }

  const props = withDefaults(defineProps<Props>(), {
    searchCriteria: HOME_SEARCH_DEFAULTS.criteria,
    activeItemType: HOME_SEARCH_DEFAULTS.itemType,
  });

  const router = useRouter();

  const hasResults = computed(() => props.documents && props.documents.length > 0);
  const shouldShowNoResults = computed(() => !hasResults.value && props.searchTerm);

  function handleClick() {
    router.push({
      path: '/pesquisa',
      query: {
        term: props.searchTerm,
        searchType: props.searchCriteria,
        type: props.activeItemType,
      },
    });
  }
</script>

<template>
  <div v-if="props.searchTerm">
    <DefaultTable
      v-if="hasResults"
      class="p-3 shadow-lg !divide-transparent"
    >
      <tbody class="bg-white-01 gap-1">
        <RecommRow :docs="props.documents" />
      </tbody>
      <ColoredButton
        text="Ver todos resultados"
        class="w-full text-center flex justify-center mt-2.5"
        :outlined="true"
        :color="'#66707A'"
        @click="handleClick"
      />
    </DefaultTable>

    <SearchNoResults v-else-if="shouldShowNoResults" />
  </div>
</template>
